import React, { useEffect, useState } from 'react'
import { TEACHER_WITH_MULTIPLE_ENTITIES_HAS_CHOSEN_ENTITY } from 'config/vars'
import { userReset } from 'utils/analytics/analytics'
import { removeCookieOnDomain } from 'utils/cookies'
import { forgetCurrentDeviceProfile } from 'utils/device-profiles'
import { AUTH_ENDPOINT } from 'config/vars'
import { getQueryVariable } from 'utils/url'
import SpinnerLoader from 'components/loader'

function resolveLogoutBaseUrl() {
  if (typeof window === 'undefined') return ''

  const { hostname } = window.location
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1'
  const isNativeApp = Boolean(window.ReactNativeWebView)

  if (isLocalHost && !isNativeApp) return 'http://localhost:3001'

  return AUTH_ENDPOINT
}

const Logout = () => {
  const [done, setDone] = useState(false)

  useEffect(() => {
    if (done) return

    forgetCurrentDeviceProfile()
    removeCookieOnDomain('access_token')
    global.localStorage.removeItem(
      TEACHER_WITH_MULTIPLE_ENTITIES_HAS_CHOSEN_ENTITY
    )

    try {
      userReset()
    } catch (error) {
      console.error('Error resetting user:', error)
    }

    setDone(true)

    if (typeof window !== 'undefined' && window.ReactNativeWebView) {
      try {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'logout' })
        )
      } catch (error) {
        console.error('Error sending logout message:', error)
      }
    }

    const redirectTo = `${window.location.origin}/login`
    const logoutBaseUrl = resolveLogoutBaseUrl()
    const clientId = getQueryVariable('client_id')
    const clientIdParam = clientId
      ? `&client_id=${encodeURIComponent(decodeURIComponent(clientId))}`
      : ''
    global.location.href = `${logoutBaseUrl}/api-arvore/auth/logout?redirect=${encodeURIComponent(
      redirectTo
    )}${clientIdParam}`
  }, [done])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <SpinnerLoader />
    </div>
  )
}

export default Logout
